import React, { CSSProperties, ReactNode } from "react";
import { ClipHeight, ClipHeightProps } from "@me8eon/components";


export const SimpleClipHeight:ClipHeight = ({ children, maxHeight, scrollable = false, force = false }:ClipHeightProps) => {
    const containerStyle: CSSProperties = {
        maxHeight,  // Applies maxHeight normally
        overflowY: scrollable ? 'auto' : 'hidden',
        height: force ? maxHeight : undefined,  // Force exact height when 'force' is true
    };

    return (
        <div style={containerStyle}>
            {children}
        </div>
    );
};

